import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from 'src/app/shared/utils/loader.service';
import { finalize } from 'rxjs/operators';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { BRANDS } from 'src/app/shared/models/screen-size.enum';
import { CONSTANTS } from 'src/app/shared/constants/constants';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requestCounter = 0;

  constructor(public loaderService: LoaderService,

    private stateManagementService: StateManagementService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req instanceof HttpRequest) {

      const brand = this.stateManagementService?.getUserBrand();
      const language = this.stateManagementService?.getUserLanguage();
      const brandName = brand === BRANDS.KWIKSETUNITE ? CONSTANTS.KWIKSETUNITE : CONSTANTS.WEISERUNITE;

      req = req.clone({
        setHeaders: {
          'x-app-name': `${brandName}`,
          'x-app-ver': 'x',
          'accept-language': `${language}`
        },
      });
      if (!req.headers.get('loader')) {
        this.requestCounter++;
        this.loaderService.show();

        return next.handle(req).pipe(
          finalize(() => {
            this.requestCounter--;
            if (this.requestCounter === 0) this.loaderService.hide();
          })
        );
      }
    }

    return next.handle(req);
  }
}
